module.exports = __webpack_public_path__ + "img/double.a4422028.png";